const initialState = [];

/**
 * This reducer handles state of opened drawers:
 * Implemented the way stack works, made for the cases, where
 * u need to open few drawers and close them in reverse order.
 * Case: you open drawer inside drawer, closing second drawer
 * shouldn't close first one.
 * @example
 * const Component = () => {
 *   const [drawerStack, drawerDispatch] = React.useReducer(Drawer.reducer, []);
 *   const onDrawerClose = () => drawerDispatch({ type: 'close' });
 *   const showAddShipping = () =>
 *     drawerDispatch({
 *       type: 'open',
 *       payload: {
 *         title: 'Add an Address',
 *         content: <ClientAccountShippingForm onCancel={onDrawerClose} />,
 *       },
 *     });
 *
 *   //...
 *
 *   return (
 *     <Drawer
 *       title={drawerStack[drawerStack.length - 1].title || ''}
 *       open={!!drawerStack[drawerStack.length - 1]}
 *       onClose={onDrawerClose}
 *     >
 *       {drawerStack[drawerStack.length - 1].content}
 *     </Drawer>
 *   );
 * }
 */
const drawerReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'open': {
      return [...state, action.payload];
    }
    case 'close': {
      return state.slice(0, -1);
    }
    case 'closeAll': {
      return [];
    }
    default:
      return state;
  }
};

export default drawerReducer;
